import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  IconButton,
  Input,
  Spinner,
  Table,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Tbody,
  VStack,
  Switch,
  HStack,
  Collapse,
  useToast,
} from "@chakra-ui/react";
import {
  ChevronDownIcon,
  ChevronUpIcon,
  EditIcon,
  TriangleDownIcon,
  TriangleUpIcon,
} from "@chakra-ui/icons";
import API from "../../context/API";
import CustomersDropDown from "./CutomersDropDown";
import Pagination from "../Common/Pagination/Pagination";

const Loyalty = () => {
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    loyaltyEnabled: false,
    loyaltyRedeemRatio: "",
    loyaltySpendRatio: "",
    minSpentForLoyalty: "",
    minSpentForRedemption: "",
  });
  const [isEditing, setIsEditing] = useState(false);
  const toast = useToast();
  const [customersLoyalties, setCutomersLoyalties] = useState([]);
  const [merchantId, setMerchantId] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10); // Default items per page
  const user = JSON.parse(localStorage.getItem("user"));

  const fetchCustomerLoyalties = async () => {
    try {
      setLoading(true);
      const response = await API.get("/merchant/loyalty/users", {
        params: { merchantId: merchantId, page: currentPage, limit:limit },
      });
      console.log("response", response);
      setCutomersLoyalties(response.data.data.data || []);
      setTotalPages(response.data.data.meta.lastPage);
    } catch (error) {
      console.error("Error fetching stores:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleToggleCollapse = (id) => {
    setCutomersLoyalties((prevData) =>
      prevData.map((loyalty) =>
        loyalty.id === id
          ? { ...loyalty, isOpen: !loyalty.isOpen }
          : { ...loyalty, isOpen: false }
      )
    );
  };
  const fetchUserDetails = async () => {
    console.log("user", user);
    try {
      const endpoint =
        user.role === "merchant" ? "merchant/profile" : "admin/profile";
      const response = await API.get(endpoint);
      setFormData({
        loyaltyEnabled: response.data.data.loyaltyEnabled,
        loyaltyRedeemRatio: response.data.data.loyaltyRedeemRatio,
        loyaltySpendRatio: response.data.data.loyaltySpendRatio,
        minSpentForLoyalty: response.data.data.minSpentForLoyalty,
        minSpentForRedemption: response.data.data.minSpentForRedemption,
      });
      setLoading(false);
    } catch (error) {
      toast({
        title: "Error fetching user details.",
        description: error.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleEdit = (section) => {
    setIsEditing(true);
  };

  useEffect(() => {
    fetchUserDetails();
  }, []);
  useEffect(() => {
    fetchCustomerLoyalties();
  }, [merchantId,limit,currentPage]);

  const handleSave = async () => {
    try {
      const updatedData = {
        loyaltyEnabled: formData.loyaltyEnabled,
        loyaltyRedeemRatio: formData.loyaltyRedeemRatio,
        loyaltySpendRatio: formData.loyaltySpendRatio,
        minSpentForLoyalty: formData.minSpentForLoyalty,
        minSpentForRedemption: formData.minSpentForRedemption,
      };
      if (user.role === "merchant") {
        await API.put(`/merchant/${user.id}`, updatedData);
      }
      setIsEditing(false);
      toast({
        title: "User details updated.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
    } catch (error) {}
  };
  const handleCancel = () => {
    setIsEditing(false);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleItemsPerPageChange = (lim) => {
    setLimit(lim);
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  const bgColor = useColorModeValue("white", "gray.800");

  return (
    <Box my={"4"}>
      <Flex justify="space-between" align="center" marginBottom="4">
        <Box>
          <Heading size={"xl"} letterSpacing={-2}>
            Loyalty
          </Heading>
          {/* <Text fontSize={"sm"}>
            List of all Loyalty, you can add new ones, edit and/or delete older
            ones.
          </Text> */}
        </Box>
      </Flex>
      {/* Loyality Section */}
      {user.role === "merchant" && (
        <Box
          padding="4"
          borderWidth="1px"
          borderRadius="md"
          boxShadow="sm"
          marginBottom="4"
        >
          <Flex
            justifyContent="space-between"
            alignItems="center"
            marginBottom="4"
          >
            <Heading size="md">Loyalty</Heading>
            <IconButton
              icon={<EditIcon />}
              onClick={() => handleEdit("loyalty")}
            />
          </Flex>

          <VStack spacing="4" align="start">
            {!isEditing ? (
              <>
                {formData.loyaltyEnabled ? (
                  <>
                    <Text>
                      <strong>Loyalty Redeem Ratio:</strong>
                      {formData?.loyaltyRedeemRatio ||
                        "Loyalty Redeem Ratio not provided"}
                    </Text>
                    <Text>
                      <strong>Loyalty Spend Ratio:</strong>
                      {formData?.loyaltySpendRatio ||
                        "Loyalty Spend Ratio not provided"}
                    </Text>
                    <Text>
                      <strong>Minimum Spent For Loyalty:</strong>
                      {formData?.minSpentForLoyalty ||
                        "Minimum Spent For Loyalty not provided"}
                    </Text>
                    <Text>
                      <strong>Minimum Spent For Redemption:</strong>
                      {formData?.minSpentForRedemption ||
                        "Minimum Spent For Redemption not provided"}
                    </Text>
                  </>
                ) : (
                  <Switch
                    id="loyaltyEnabled"
                    name="loyaltyEnabled"
                    isChecked={formData.loyaltyEnabled}
                    isDisabled
                  />
                )}
              </>
            ) : (
              <>
                {/* If editing is enabled, show loyalty enabled toggle */}
                <FormControl>
                  <FormLabel>Loyalty Enabled</FormLabel>
                  <Switch
                    id="loyaltyEnabled"
                    name="loyaltyEnabled"
                    isChecked={formData.loyaltyEnabled}
                    onChange={handleInputChange}
                  />
                </FormControl>

                {/* If loyalty is enabled, show these two fields */}
                {formData?.loyaltyEnabled && (
                  <HStack width={"100%"}>
                    <FormControl>
                      <FormLabel>Loyalty Redeem Ratio</FormLabel>
                      <Input
                        name="loyaltyRedeemRatio"
                        value={formData.loyaltyRedeemRatio}
                        onChange={handleInputChange}
                        isDisabled={!isEditing} // Disable if editing is false
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel>Loyalty Spend Ratio</FormLabel>
                      <Input
                        name="loyaltySpendRatio"
                        value={formData.loyaltySpendRatio}
                        onChange={handleInputChange}
                        isDisabled={!isEditing} // Disable if editing is false
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel>Minimum Spent For Loyalty</FormLabel>
                      <Input
                        name="minSpentForLoyalty"
                        value={formData.minSpentForLoyalty}
                        onChange={handleInputChange}
                        isDisabled={!isEditing} // Disable if editing is false
                      />
                    </FormControl>
                    <FormControl>
                      <FormLabel>Minimum Spent For Redemption</FormLabel>
                      <Input
                        name="minSpentForRedemption"
                        value={formData.minSpentForRedemption}
                        onChange={handleInputChange}
                        isDisabled={!isEditing} // Disable if editing is false
                      />
                    </FormControl>
                  </HStack>
                )}

                {/* Save and Cancel buttons */}
                <HStack spacing="4">
                  <Button colorScheme="teal" onClick={handleSave}>
                    Save
                  </Button>
                  <Button onClick={handleCancel}>Cancel</Button>
                </HStack>
              </>
            )}
          </VStack>
        </Box>
      )}

      <Box p={4} bg={bgColor} borderRadius="md" overflowX="auto">
        {user.role === "admin" && (
          <Box display={"flex"} justifyContent={"flex-end"} width={"100%"}>
            <Box display={"flex"}>
              <CustomersDropDown
                onOptionSelect={(option) => {
                  setMerchantId(option.id);
                }}
              />
            </Box>
          </Box>
        )}

        {loading ? (
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100vh"
          >
            <Spinner size="xl" />
          </Box>
        ) : (
          <>
            <CustomersLoyaltyTable
              customersLoyalties={customersLoyalties}
              handleToggleCollapse={handleToggleCollapse}
            />
            <Box w="full" mt={4}>
              <Pagination
                currentPage={currentPage}
                itemsPerPage={limit}
                totalPages={totalPages}
                onItemsPerPageChange={handleItemsPerPageChange}
                onPageChange={handlePageChange}
              />
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};
const CustomersLoyaltyTable = ({
  customersLoyalties,
  handleToggleCollapse,
}) => {
  // Chakra UI color modes
  const bgColor = useColorModeValue("white", "gray.800");
  const tableBg = useColorModeValue("gray.50", "gray.700");
  const textColor = useColorModeValue("gray.800", "white");
  const subTextColor = useColorModeValue("gray.600", "gray.500");
  const borderColor = useColorModeValue("gray.200", "gray.600");

  // Sorting state
  const [sortConfig, setSortConfig] = useState({
    key: null, // Column key
    direction: "asc", // 'asc' or 'desc'
  });

  // Helper functions
  const getPhoneBlurred = (phone) => {
    if (phone.length > 4) {
      return phone.slice(0, -4);
    } else {
      return phone.slice(0, -2);
    }
  };
  const getPhoneUnBlurred = (phone) => {
    if (phone.length > 4) {
      return phone.slice(-4);
    } else {
      return phone.slice(-2);
    }
  };
  const formatDateAndTime = (isoString) => {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString("en-GB");
    const formattedTime = date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return { formattedDate, formattedTime };
  };

  // Sorting handler
  const handleSort = (columnKey) => {
    let direction = "asc";
    if (sortConfig.key === columnKey && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key: columnKey, direction });
  };

  // Function to sort data based on sortConfig
  const sortedData = useMemo(() => {
    let sortableData = [...customersLoyalties];
    if (sortConfig.key !== null) {
      sortableData.sort((a, b) => {
        let aValue, bValue;

        switch (sortConfig.key) {
          case "name":
            aValue = a.user.name.toLowerCase();
            bValue = b.user.name.toLowerCase();
            break;
          case "phone":
            aValue = a.user.phone;
            bValue = b.user.phone;
            break;
          case "points":
            aValue = parseFloat(a.points);
            bValue = parseFloat(b.points);
            break;
          case "totalSpent":
            aValue = parseFloat(a.totalSpent);
            bValue = parseFloat(b.totalSpent);
            break;
          default:
            aValue = "";
            bValue = "";
        }

        if (aValue < bValue) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (aValue > bValue) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  }, [customersLoyalties, sortConfig]);

  // Function to render sort icons
  const renderSortIcon = (columnKey) => {
    if (sortConfig.direction === "asc" && sortConfig.key === columnKey) {
      return <TriangleUpIcon ml={2} />;
    }
    return <TriangleDownIcon ml={2} />;
  };

  return (
    <Box
      overflowX="auto" // Allows horizontal scrolling on smaller screens
      borderRadius="md"
      mt="4"
      p="4"
      bg={bgColor}
      boxShadow="md"
    >
      <VStack align="start" spacing={4}>
        {/* Header Section */}
        <Box>
          <Text fontSize="2xl" fontWeight="bold">
            Customers Loyalty
          </Text>
          <Text fontSize="sm" color={subTextColor}>
            Overview of customer loyalty points and spending.
          </Text>
        </Box>

        {/* Table Section */}
        <Table
          variant="simple"
          size="sm" // Ensures compact table size for better visibility
          minWidth="600px" // Minimum width to maintain structure
          sx={{
            "@media (max-width: 1440px)": {
              fontSize: "sm",
            },
            "@media (max-width: 1024px)": {
              fontSize: "xs",
            },
            "@media (max-width: 768px)": {
              fontSize: "xs",
            },
          }}
        >
          <Thead>
            <Tr>
              {/* Name Column */}
              <Th
                cursor="pointer"
                onClick={() => handleSort("name")}
                userSelect="none"
              >
                <Box display="flex" alignItems="center">
                  Name
                  {renderSortIcon("name")}
                </Box>
              </Th>

              {/* Phone Column */}
              <Th
                cursor="pointer"
                onClick={() => handleSort("phone")}
                userSelect="none"
              >
                <Box display="flex" alignItems="center">
                  Phone
                  {renderSortIcon("phone")}
                </Box>
              </Th>

              {/* Points Column */}
              <Th
                cursor="pointer"
                onClick={() => handleSort("points")}
                userSelect="none"
              >
                <Box display="flex" alignItems="center">
                  Points
                  {renderSortIcon("points")}
                </Box>
              </Th>

              {/* Total Spent Column */}
              <Th
                cursor="pointer"
                onClick={() => handleSort("totalSpent")}
                userSelect="none"
              >
                <Box display="flex" alignItems="center">
                  Total Spent
                  {renderSortIcon("totalSpent")}
                </Box>
              </Th>

              {/* Actions Column (Not Sortable) */}
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody>
            {sortedData.map((loyalty, index) => (
              <React.Fragment key={loyalty.id}>
                {/* Customer Row */}
                <Tr bg={tableBg} borderBottomColor={borderColor}>
                  <Td color={textColor}>{loyalty.user.name}</Td>
                  <Td color={textColor}>
                    <Box display={"flex"} alignItems="center">
                      <Text
                        display={"flex"}
                        as="span"
                        filter="blur(3px)"
                        whiteSpace={"nowrap"}
                      >
                        {getPhoneBlurred(loyalty.user.phone)}
                      </Text>
                      <Text as="span" ml="2">
                        {getPhoneUnBlurred(loyalty.user.phone)}
                      </Text>
                    </Box>
                  </Td>
                  <Td color={textColor}>
                    {parseFloat(loyalty.points).toFixed(2)}
                  </Td>
                  <Td color={textColor}>{loyalty.totalSpent}</Td>
                  <Td>
                    <Button
                      variant="link"
                      onClick={() => handleToggleCollapse(loyalty.id)}
                      rightIcon={
                        loyalty.isOpen ? <ChevronUpIcon /> : <ChevronDownIcon />
                      }
                    >
                      {loyalty.isOpen ? "Hide Details" : "View Details"}
                    </Button>
                  </Td>
                </Tr>

                {/* Collapsible Row for Transactions */}
                <Tr>
                  <Td colSpan={5} p="0">
                    <Collapse in={loyalty.isOpen} animateOpacity>
                      <Box p="4" borderWidth="1px" borderRadius="md" mb="4">
                        <Heading size="md" mb="4">
                          Transactions
                        </Heading>
                        <VStack align="start" spacing="4">
                          <Table variant="simple" size="sm" w="full">
                            <Thead>
                              <Tr>
                                <Th>Points Earned</Th>
                                <Th>Points Redeemed</Th>
                                <Th>Transaction Amount</Th>
                                <Th>Date & Time</Th>
                              </Tr>
                            </Thead>
                            <Tbody>
                              {loyalty?.loyaltyPoints[0]?.transactions?.map(
                                (transaction, txnIndex) => (
                                  <Tr key={transaction.id || txnIndex}>
                                    <Td>{transaction.pointsEarned}</Td>
                                    <Td>{transaction.pointsRedeemed}</Td>
                                    <Td>{transaction.transactionAmount}</Td>
                                    <Td>
                                      {
                                        formatDateAndTime(transaction.date)
                                          .formattedDate
                                      }{" "}
                                      {
                                        formatDateAndTime(transaction.date)
                                          .formattedTime
                                      }
                                    </Td>
                                  </Tr>
                                )
                              )}
                            </Tbody>
                          </Table>
                        </VStack>
                      </Box>
                    </Collapse>
                  </Td>
                </Tr>
              </React.Fragment>
            ))}
          </Tbody>
        </Table>
      </VStack>
    </Box>
  );
};

export default Loyalty;
